import {
  conditionDisclaimers,
  getDisclaimerAnchor,
  getDisclaimerAnchorLinkText,
  getDisclaimerDescriptionMarkup,
  getDisclaimerTypeByCondition,
} from './conditionDisclaimers';

import { MYEV_API_BASE } from '../config';
import groupBy from '../utils/groupBy';
import { setUpClickHandlers } from '../utils/clickHandlers';

/**
 * Fetches a list of diseases we test for, groups related items,
 * wraps them in HTML and draws them to the page.
 *
 * @since 2018-06-24
 * @uses groupBy
 * @see sections/product-template.liquid
 */
export async function drawDiseaseList() {
  // Container to place generated HTML inside.
  const $mountNode = $('#diseases-list #diseases-list__mount');
  if (!$mountNode.length) {
    return; // Exit early if there is nowhere to draw the list.
  }

  const diseaseObjects = await $.get(`${MYEV_API_BASE}/health-and-breed-list`);

  if (!Array.isArray(diseaseObjects)) {
    return;
  }

  diseaseObjects.push({
    health_id: '000000',
    lay_term: 'Skin & Connective Tissues',
    disorder_name: 'Mast Cell Tumor (MCT)',
    subdisorder_name: '',
    is_recommended_by_embark: true,
    is_recommended_by_ofa: false,
    is_linkage_test: false,
    is_ancestry_based_risk: true,
    breed_display_names:
      'Alapaha Blue Blood Bulldog, , American Bulldog, , American Bully, , American Pit Bull Terrier, , American Staffordshire Terrier, , Boston Terrier, , Boxer, , Bull Terrier, , English Bulldog, , Dogo Argentino, , French Bulldog, , Miniature Bull Terrier, , Olde English Bulldogge, , Staffordshire Bull Terrier, , Staffordshire Terrier',
  });

  const categories = groupBy(diseaseObjects, 'lay_term');
  const html = [];
  const disclaimersOutput = {};

  html.push('<ul class="accordion__root accordion">');

  Object.keys(categories).forEach((key) => {
    const diseaseItems = categories[key]
      .map((d) => {
        let disclaimerText = '';
        const disclaimerType = getDisclaimerTypeByCondition(d);

        if (
          disclaimerType &&
          typeof conditionDisclaimers[disclaimerType] !== 'undefined'
        ) {
          const anchorID = getDisclaimerAnchor(
            disclaimerType,
            d.health_id,
            'diseaseList'
          );

          disclaimersOutput[disclaimerType] = anchorID;
          disclaimerText =
            '<br>' +
            getDisclaimerAnchorLinkText(
              anchorID,
              conditionDisclaimers[disclaimerType].anchorText
            );
        }
        return `<li><span class="bold">${d.disorder_name}</span> ${d.subdisorder_name}${disclaimerText}</li>`;
      })
      .join('');
    html.push(
      `<li class="accordion__item">
          <h5 class="h6"><button type="button" tabindex="0" aria-expanded="false" aria-controls="accordion__list-${key.replace(
            ' ',
            ''
          )}">${key}</button></h5>
		      <ul id="accordion__list-${key.replace(' ', '')}">
            ${diseaseItems}
		      </ul>
         </li>`
    );
  });

  html.push('</ul>');
  Object.keys(disclaimersOutput).forEach((key) => {
    const disclaimerdescriptionMarkup = getDisclaimerDescriptionMarkup(
      disclaimersOutput[key],
      conditionDisclaimers[key].descriptionMarkup
    );

    if (disclaimerdescriptionMarkup) {
      html.push(disclaimerdescriptionMarkup);
    }
  });
  $mountNode.html(html.join(''));
  setUpClickHandlers($mountNode);
}
